import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectPostClosingOptions = createSelector(
  getSystem,
  ({ postClosingOptions }) => postClosingOptions,
);

const sortBySortOrder = items =>
  _.sortBy(items, ['sortOrder', ({ displayName }) => _.toLower(displayName)]);

export const selectPostClosingOptionsByListType = createSelector(
  selectPostClosingOptions,
  ({ effectiveByListType }) =>
    _.mapValues(effectiveByListType, items =>
      sortBySortOrder(items).map(({ value, displayName }) => ({ value, name: displayName })),
    ),
);

export const selectPostClosingAdminOptionsByListType = createSelector(
  selectPostClosingOptions,
  ({ adminByListType, effectiveByListType }) =>
    _.mapValues(adminByListType, ({ usingDefaults }, listType) => ({
      usingDefaults,
      items: sortBySortOrder(
        usingDefaults ? effectiveByListType[listType] : adminByListType[listType].items,
      ),
    })),
);
